const ReconciliationStatus = {
  RECONCILED: 'RECONCILED',
  PENDING: 'PENDING'
};

export default ReconciliationStatus;
